module.exports = __webpack_public_path__ + "static/media/about-img2.c8ebd4f4.png";